import { render } from "./App.vue?vue&type=template&id=2781c02f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/michael/share/nfs-share/eschenbach-eyewear/web/wp-content/plugins/eon-vue-wishlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__